import * as React from "react";
import { Subtract } from "utility-types";

export function useLanguage(): string {
    const [lang, setLang] = React.useState<string>(window.navigator.language);

    React.useEffect(() => {
        const onLanguageChange = () => {
            setLang(window.navigator.language);
        };
        window.addEventListener("languagechange", onLanguageChange);
        return () => window.removeEventListener("languagechange", onLanguageChange);
    }, []);

    return lang;
}

interface WithLanguageProps {
    readonly language: string;
}

export const withLanguage = <P extends WithLanguageProps>(
    Component: React.ComponentType<P>
): React.FunctionComponent<Subtract<P, WithLanguageProps>> => p => {
    const language = useLanguage();
    return <Component {...(p as P)} language={language} />;
};
